module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_facebook-a4063e80fdafe966162e0a3514adbce0.svg";